<template>
  <div class="cronus-header__chapters" :class="{'open': openMenu}">
      <h3 class="title">Chapters<span @click="openMenu=!openMenu" class="close-chapters"><img :src="imgIcon('close-chapters.png')" alt="Chapters Luanda Leaks"></span></h3>
    <ol>
      <li :key="chapter.id" v-for="chapter in data.chapters" @click="changeScene(chapter.anchor)" :class="{'active': selectChapter(chapter.id) }" class="chapters-nav__chapter">
        <img :src="imgIcon(chapter.icon)">
        <div class="chapter_name">
          <div>{{ chapter.title }}</div>
          <div class="chapter_period">{{ chapter.period }}</div>
        </div>
      </li>
      <li class="chapters-nav__chapter">
        <img :src="imgIcon('newsletter_icon.png')">
        <div class="chapter_name">
          <sign-up-form tracker="WEB-CRONUS" />
        </div>
      </li>
    </ol>
  </div>
</template>

<script>

  import { SignUpForm } from '@icij/murmur'

  export default {
    name: "headerStory",
    components: {
      SignUpForm
    },
    props: {
      data: Object,
      showMenu: Boolean,
      currentChapter: Number
    },
    data() {
      return {
        openMenu: this.showMenu
      }
    },
    watch: {
      showMenu(v) {
        this.openMenu = v
      }
    },
    methods: {
      imgIcon(icon) {
        return require(`../assets/${icon}`)
      },
      changeScene(scene) {
        const target = document.getElementById(scene)
        target.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"})
      },
      selectChapter(chapter) {
        if(this.currentChapter == chapter)
          return true
        return false
      }
    }
  }

</script>

<style lang="scss">

  .cronus-header__chapters {
    position: fixed;
    bottom: 0px;
    right: -241px;
    width: calc(100% - 20px);
    max-width: 325px;
    max-height: 90vh;
    padding: 10px;
    font-size: 18px;
    font-weight: 600;
    background: transparent;
    transition: right .25s ease-in-out;
    overflow: auto;

    h3.title {
      padding: 10px 0;
      font-family: 'Merriweather', serif;
      font-size: 15px;
      font-weight: 400;
      color: #797979;
    }

    h3.title img.title {
      width: 85px;
    }

    span.close-chapters {
      display: block;
      text-align: right;
      float: right;
      opacity: 0;
    }

    &__logo {
      display: flex;
      align-items: center;
      font-size: 27px;
    }

    &.open,
    &:hover {
      right: 0;
    }

    li {
      display: flex;
      align-items: center;
      padding: 10px;
      margin-left: 10px;
      font-family: 'Merriweather', serif;
      color: #ce1329;
      cursor: pointer;
    }

    .active {
      background: aliceblue;
    }

    .chapter_name {
      font-size: 14px;
    }

    .chapter_period {
      font-size: 12px;
      color: #a0a0a0;
    }

    img {
      width: 40px;
      margin-right: 15px;
    }

    .text-muted {
      font-size: 15px;
      font-weight: 400;
    }

    .font-weight-bold {
      font-weight: 400 !important;
      text-transform: capitalize !important;
    }

    .btn-primary {
      color: #fff;
      background-color: #484848;
      border-color: #484848;
      box-shadow: none;
    }
  }

  @media (min-width: 200px) and (max-width: 640px) {
    .cronus-header__chapters {
      top: 53px;
      right: -100vw !important;
      width: 100%;
      max-width: 100%;
      padding: 0;
      background: #fffffff0;
      transition: right .35s ease-in-out;
      z-index: 999;
    }

    .open-menu-mobile {
      display: block;
      position: sticky;
      bottom: 0;
      text-align: right;
    }

    span.close-chapters {
      display: block;
      text-align: right;
      float: right;
      opacity: 1 !important;
    }

    .cronus-header__chapters.open{
      right: 0 !important;
    }

    .cronus-header__chapters h3.title {
      padding: 15px;
    }
  }

  .luandaleaks-logo {
    min-width: 55px;
    min-height: 55px;
    margin-right: 15px;
    background: #852308 url(../assets/icij-black.svg) no-repeat center center;
    background-repeat: no-repeat;
    background-size: 50px 50px;
  }

</style>